export default {"src":"/_next/static/media/category-dark.f3664f75.svg","height":256,"width":256};